// extracted by mini-css-extract-plugin
module.exports = {"opportunity":"_ab4ce5f"};